(() => {
  const toggle = document.querySelector('[data-mega-nav-toggle]');
  const closeBtn = document.querySelector('[data-mega-nav-close]');
  const megaNav = document.querySelector('[data-mega-nav]');
  const scrim = document.querySelector('[data-mega-nav-scrim]');

  if (!toggle || !megaNav || !scrim) return;

  function openMegaNav() {
    scrim.hidden = false;
    megaNav.classList.add('is-open');
    megaNav.setAttribute('aria-hidden', 'false');
    megaNav.inert = false;
    toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMegaNav() {
    megaNav.classList.remove('is-open');
    megaNav.setAttribute('aria-hidden', 'true');
    megaNav.inert = true;
    scrim.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  toggle.addEventListener('click', () => {
    const isOpen = toggle.getAttribute('aria-expanded') === 'true';
    isOpen ? closeMegaNav() : openMegaNav();
  });

  if (closeBtn) closeBtn.addEventListener('click', closeMegaNav);
  scrim.addEventListener('click', closeMegaNav);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeMegaNav();
  });

  document.querySelectorAll('[data-mega-nav-secondary-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const panel = btn.nextElementSibling;
      const isOpen = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      if (panel) panel.hidden = isOpen;
    });
  });
})();
